import React from "react";
import css from "./section.module.css";
import resources from "./../../../../resources/index";
import {FaPlay} from 'react-icons/fa'
const Section1 = () => {
  return (
    <div className={css.section1}>

      <div className={css.left}>
        <h1>Get Fully Control and Visibility your Company</h1>
        <p>
          Proactively coordinate quality quality vectors vis-a-vis supply
          chains. Quickly engage client-centric web services.
        </p>
        <div className={css.btns}>
          <button className={css.request}>Request for Demo</button>
          <button className={css.watch}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaPlay className={css.play} />
              Watch Demo
            </div>
          </button>
        </div>
        <div className={css.clients}>
          <h6>Our Top Clients:</h6>
          <div className={css.clients_logo}>
          <div>
            <img src={resources.icons.rotaShow} alt="clients" />
          </div>
          <div>
            <img src={resources.icons.waves} alt="clients" />
          </div>
          <div>
            <img src={resources.icons.rotaShow} alt="clients" />
          </div>
          </div>
        </div>
      </div>

      <div className={css.right}>
        <img src={resources.images.home_sec1} alt="Hero" />
      </div>
      
    </div>
  );
};

export default Section1;
